import Cookies from "js-cookie";
import jwt from "jsonwebtoken";
import router from "@/router";
import { LOGIN_SUCCESS } from "@/store/constants/messages";
import { SET_LOADING } from "@/store/constants/mutation-types";

const state = {
  token: Cookies.get("token") || null,
  refreshToken: Cookies.get("refreshToken") || null
};

const getters = {
  isAuthenticated(state) {
    return !!state.token;
  },
  getToken(state) {
    return state.token;
  },
  getRefreshToken(state) {
    return state.refreshToken;
  }
};

const mutations = {
  login(state, userData) {
    state.token = userData.token;
    state.refreshToken = userData.refresh_token;
  },
  setToken(state, token) {
    state.token = token;
  },
  setRefreshToken(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  unsetToken(state) {
    state.token = null;
  },
  unsetRefreshToken(state) {
    state.refreshToken = null;
  },
  logout(state) {
    Cookies.remove("token");
    Cookies.remove("refreshToken");
    state.token = null;
    state.refreshToken = null;
  }
};

const actions = {
  login({ commit, dispatch }, authData) {
    commit(SET_LOADING, true, { root: true });

    this._vm.$gwzApi
      .service("users")
      .login(authData)
      .then(res => {
        commit("login", res.data);
        // this._vm.$gwzApi.setInterceptors();
        this._vm.$gwzAuthCookies.set(res.data);
        commit(SET_LOADING, false, { root: true });
        router.push({ name: "Home" });
        dispatch("setSuccessToast", LOGIN_SUCCESS, { root: true });
        return res;
      })
      .catch(err => {
        commit(SET_LOADING, false, { root: true });
        dispatch("setErrorToast", err?.message, {
          root: true
        });
      });
  },
  logout({ commit }) {
    commit("logout");
  },
  setToken({ commit }, token) {
    commit("setToken", token);
  },
  setRefreshToken({ commit }, refreshToken) {
    commit("setRefreshToken", refreshToken);
  },
  unsetToken({ commit }) {
    commit("unsetToken");
  },
  unsetRefreshToken({ commit }) {
    commit("unsetRefreshToken");
  },
  tryAutoLogin({ commit }) {
    const token = Cookies.get("token");
    const refreshToken = Cookies.get("refreshToken");

    if (!(token && refreshToken)) {
      return false;
    }

    const decoded = jwt.decode(token);
    const now = Math.floor(Date.now() / 1000);

    if (now > decoded.exp) {
      commit("unsetToken");
      this._vm.$gwzAuthCookies.unset();
      return false;
    }
    this._vm.$gwzAuthCookies.set({ token, refresh_token: refreshToken });
    return true;
  }
};
const modules = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules
};
